import React from "react";
import { BaseDistributorLogoProps } from "./DistributorLogo";
import DistributorLogoThemes from "./DistributorLogoThemes";

export default function PattersonLogo({
  className,
  width = 77,
  height = 32,
  theme,
}: BaseDistributorLogoProps): React.JSX.Element {
  if (theme === DistributorLogoThemes.Light) {
    return (
      <span className="text-xs text-error">
        Distributor logo theme '{theme}' not supported
      </span>
    );
  }

  if (theme === DistributorLogoThemes.Icon) {
    return (
      <svg
        className={className}
        width={width}
        height={height}
        viewBox="0 0 500 500"
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#003767" width="500" height="500" />
        <g>
          <path
            fill="#FFFFFF"
            d="M183.75,193.77c-23.98,2.17-55.02,12.79-72.4,20.4-30.88,15.76-51.89,33.82-64.24,46.61,7.84-.21,16.07-.02,24.72.73,29.24,2.59,52.47,9.41,70.69,17.72,15.82-14.89,41.59-40.24,74.81-49.93,57.51-16.82,95.34,10.86,95.34,10.86,0,0-29.47-55.37-128.91-46.38Z"
          />
          <path
            fill="#FFFFFF"
            d="M314.92,305.73c23.99-2.17,55.03-12.78,72.39-20.4,30.89-15.75,51.9-33.82,64.26-46.62-7.84.22-16.09.03-24.7-.73-29.24-2.6-52.48-9.4-70.73-17.72-15.81,14.9-41.59,40.25-74.78,49.95-57.54,16.8-95.38-10.86-95.38-10.86,0,0,29.49,55.37,128.94,46.38Z"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 151.86 63.23"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            fill="#003767"
            d="M3.89,28.75c1.14.05,2.28.05,3.42.05.86,0,1.75-.05,2.81-.05,2.61,0,6.36,1.09,6.36,5.04,0,2.99-2.79,5.07-5.45,5.07-.5,0-.91-.02-1.29-.02v-.84c.33.05.63.05.96.05,2.18,0,3.14-2.15,3.14-3.98,0-3.52-2.46-4.51-4.13-4.51-.38,0-.84.03-1.12.08v14.32c0,1.77.96,1.8,2.33,1.82v.66c-1.24,0-2.33-.05-3.45-.05-1.22,0-2.41.02-3.67.05v-.66c1.34-.02,2.31-.05,2.31-1.82v-12.06c0-1.95-.33-2.48-2.23-2.48v-.66Z"
          />
          <path
            fill="#003767"
            d="M30.14,41.4c.36.99,1.04,3.14,1.44,3.7.38.51,1.14.68,1.95.68v.66c-.96,0-1.95-.05-2.91-.05-1.24,0-2.46.02-3.7.05v-.66h.46c.63,0,1.39-.12,1.39-.83,0-.28-.2-.99-.38-1.47l-1.27-3.67h-5.95l-.56,1.78c-.33,1.06-.68,2.23-.68,3.01,0,1.19.84,1.14,1.72,1.19h.58v.66c-.99,0-2-.05-2.99-.05s-2.05.02-3.06.05v-.66c1.54-.17,1.82-.38,2.46-1.8.4-.91.71-1.9,1.04-2.84l3.24-9.04c.2-.58.53-1.52.53-2.28,0-.25,0-.46-.05-.66.53-.25,1.12-.53,1.47-1.11h.43l4.84,13.35ZM21.53,38.76h5.22l-2.71-7.45h-.05l-2.46,7.45Z"
          />
          <path
            fill="#003767"
            d="M62.88,28.05c-.1.48-.74.71-1.65.71h-26.48c-.63,0-1.32-.03-1.6-.71h-.5l-.28,4.03h.66c.43-1.64.53-2.28,2.81-2.28h3.32v14.16c0,1.77-.96,1.8-2.31,1.82v.66c1.26-.03,2.46-.05,3.67-.05,1.12,0,2.2.05,3.42.05v-.66c-1.34-.02-2.31-.05-2.31-1.82v-14.16h3.85c1.4,0,1.79.58,1.92,1.3l.06.98h.73l.05-.98c.12-.73.32-1.3,2.03-1.3h3.85v14.16c0,1.77-.97,1.8-2.31,1.82v.66c1.27-.03,2.46-.05,3.67-.05,1.11,0,2.2.05,3.42.05v-.66c-1.34-.02-2.31-.05-2.31-1.82v-14.16h3.86c2.02,0,1.95.91,2.02,2.28h.69l.22-4.03h-.53Z"
          />
          <path
            fill="#003767"
            d="M68.88,36.76h3.35c2.05,0,2.05-1.59,2.12-2.18h.51c-.05.56-.1,1.93-.1,2.84,0,.81.13,2,.1,2.81h-.51c0-2.43-.81-2.43-2.76-2.43h-2.71v4.31c0,2.81.1,3.52,2.61,3.52h1.57c2.48-.13,3.6-.46,4.58-3.17l.61.11c-.4,1.26-.78,2.56-1.04,3.88-2.53,0-5.07-.05-7.6-.05-1.87,0-3.75,0-5.62.05v-.66c2.21,0,2.4-.4,2.4-2.86v-11.25c0-2.08-.4-2.18-2.4-2.26v-.66c1.7.05,3.42.05,5.12.05,2.43,0,4.84,0,7.3-.05v3.78l-.51.12c-.38-2.38-1.52-3.09-4.05-3.09h-2.96v7.2Z"
          />
          <path
            fill="#003767"
            d="M83.73,38.08v5.88c0,1.77.96,1.8,2.3,1.82v.66c-1.21,0-2.3-.05-3.42-.05-1.22,0-2.41.02-3.67.05v-.66c1.26.08,2.3-.25,2.3-1.7v-12.85c0-1.77-.96-1.8-2.3-1.82v-.66c1.39.02,2.61.05,3.85.05.89,0,1.77-.05,3.4-.05,4.79,0,5.85,2.69,5.85,4.48,0,2.15-1.62,3.75-3.59,4.33,2.3,3.37,3.52,5.4,4.61,6.61.81.91,1.57,1.6,2.86,1.6v.66c-.63,0-1.27-.05-1.9-.05-.71,0-1.45.02-2.16.05-2.3-2.54-4-5.5-5.83-8.36h-2.3ZM85.25,29.56c-.63,0-1.07.08-1.52.16v7.42c.38.08.91.13,1.34.13,3.12,0,4.33-2.05,4.33-3.88,0-2.2-1.16-3.83-4.16-3.83Z"
          />
          <path
            fill="#003767"
            d="M96.86,42.26h.58c.43,1.9,1.85,3.75,3.96,3.75,1.95,0,3.47-1.37,3.47-3.37,0-4.71-7.5-3.32-7.5-9.3,0-3.27,2.33-4.97,5.42-4.97,1.04,0,2.08.23,3.09.38l.4,3.25h-.58c-.28-1.78-1.45-2.82-3.27-2.82-1.92,0-3.04,1.39-3.04,3.24,0,4.71,7.81,3.42,7.81,9.25,0,3.3-2.97,5.14-5.95,5.14-1.32,0-2.69-.3-3.88-.86l-.51-3.7Z"
          />
          <path
            fill="#003767"
            d="M118.32,28.37c5.07,0,9.05,4.3,9.05,9.12s-3.57,9.32-9.12,9.32c-5.07,0-9.04-4.31-9.04-9.12s3.57-9.32,9.12-9.32ZM118.55,46.01c3.7,0,6.03-3.2,6.03-7.78,0-3.85-2.22-9.05-6.56-9.05-3.7,0-6.03,3.19-6.03,7.78,0,3.85,2.23,9.05,6.56,9.05Z"
          />
          <path
            fill="#003767"
            d="M145.66,46.67h-.58l-13.25-14.54v9.45c0,3.49.28,4.2,3.01,4.2v.66c-1.11,0-2.25-.05-3.37-.05s-2.26.02-3.38.05v-.66c1.55,0,2.71,0,2.71-3.21v-10.19c0-2.18-.94-2.96-3.12-2.96v-.66c.79.02,1.55.05,2.33.05.69,0,1.4-.05,2.08-.05,1.04,1.55,3.39,3.85,6.28,7.04,2.15,2.38,4.53,4.89,6.26,6.77v-10.08c0-2.33-.53-3.04-3.07-3.07v-.66c1.16.02,2.36.05,3.52.05.99,0,1.95-.05,2.94-.05v.66c-1.55,0-2.38.13-2.38,2.61v14.65Z"
          />
        </g>
        <g>
          <path
            fill="#003767"
            d="M65.85.19c-4.52.41-10.36,2.41-13.64,3.84-5.82,2.97-9.78,6.37-12.1,8.78,1.48-.04,3.03,0,4.66.14,5.5.49,9.88,1.77,13.31,3.33,2.98-2.8,7.84-7.58,14.08-9.4,10.83-3.17,17.96,2.05,17.96,2.05,0,0-5.55-10.43-24.28-8.74Z"
          />
          <path
            fill="#003767"
            d="M90.55,21.27c4.52-.41,10.36-2.41,13.63-3.84,5.82-2.97,9.78-6.37,12.11-8.78-1.48.04-3.03,0-4.66-.14-5.51-.49-9.89-1.77-13.32-3.34-2.98,2.81-7.83,7.58-14.08,9.41-10.84,3.16-17.96-2.05-17.96-2.05,0,0,5.55,10.43,24.28,8.73Z"
          />
        </g>
      </g>
      <g>
        <path
          fill="#003767"
          d="M2.99,56.43c-.41-1.05-.89-2.12-1.27-3.19-.38-.99-.64-1.3-1.73-1.3v-.43c.77.02,1.54.03,2.32.03.69,0,1.4-.03,2.09-.03v.43c-.25.02-.48.02-.71.05-.23.02-.43.15-.43.39,0,.54.87,2.53,1.05,3.01l2.18,5.62,1.25-3.25c.39-1.07.85-2.12,1.2-3.19.16-.53.51-1.33.51-1.87,0-.77-.66-.72-1.25-.75v-.43c.64.02,1.3.03,1.94.03.51,0,1.02-.02,1.53-.03v.43c-.56,0-.87.25-1.1.64-.1.18-1.22,3.02-1.25,3.1l-3.01,7.54h-.61l-2.73-6.8Z"
        />
        <path
          fill="#003767"
          d="M20.41,56.71h2.17c1.33,0,1.33-1.04,1.38-1.41h.33c-.03.36-.07,1.25-.07,1.84,0,.53.08,1.3.07,1.82h-.33c0-1.58-.53-1.58-1.79-1.58h-1.76v2.79c0,1.82.07,2.29,1.69,2.29h1.02c1.61-.08,2.33-.3,2.97-2.06l.4.07c-.26.82-.51,1.66-.67,2.51-1.64,0-3.29-.03-4.93-.03-1.21,0-2.43,0-3.65.03v-.43c1.43,0,1.56-.27,1.56-1.86v-7.3c0-1.35-.26-1.41-1.56-1.46v-.43c1.1.03,2.22.03,3.32.03,1.58,0,3.14,0,4.73-.03v2.45l-.33.08c-.25-1.54-.99-2-2.63-2h-1.92v4.67Z"
        />
        <path
          fill="#003767"
          d="M42.21,53.67h-.44c-.05-.89,0-1.48-1.32-1.48h-2.5v9.19c0,1.15.62,1.17,1.5,1.18v.43c-.79,0-1.5-.03-2.22-.03-.79,0-1.56.02-2.38.03v-.43c.87-.02,1.5-.03,1.5-1.18v-9.19h-2.15c-1.48,0-1.54.41-1.82,1.48h-.43l.18-2.61h.33c.18.44.62.46,1.04.46h7.46c.59,0,1-.15,1.07-.46h.35l-.15,2.61Z"
        />
        <path
          fill="#003767"
          d="M51.25,56.71h2.17c1.33,0,1.33-1.04,1.38-1.41h.33c-.03.36-.07,1.25-.07,1.84,0,.53.08,1.3.07,1.82h-.33c0-1.58-.53-1.58-1.79-1.58h-1.76v2.79c0,1.82.07,2.29,1.69,2.29h1.02c1.61-.08,2.33-.3,2.97-2.06l.39.07c-.26.82-.51,1.66-.67,2.51-1.64,0-3.29-.03-4.93-.03-1.21,0-2.43,0-3.65.03v-.43c1.43,0,1.56-.27,1.56-1.86v-7.3c0-1.35-.26-1.41-1.56-1.46v-.43c1.1.03,2.22.03,3.32.03,1.58,0,3.14,0,4.73-.03v2.45l-.33.08c-.25-1.54-.98-2-2.63-2h-1.92v4.67Z"
        />
        <path
          fill="#003767"
          d="M66.22,57.56v3.81c0,1.15.62,1.17,1.5,1.18v.43c-.79,0-1.5-.03-2.22-.03-.79,0-1.56.02-2.38.03v-.43c.82.05,1.5-.16,1.5-1.1v-8.33c0-1.15-.62-1.17-1.5-1.18v-.43c.91.02,1.69.03,2.5.03.58,0,1.15-.03,2.2-.03,3.11,0,3.8,1.74,3.8,2.91,0,1.4-1.05,2.43-2.33,2.81,1.49,2.19,2.28,3.5,2.99,4.29.53.59,1.02,1.04,1.86,1.04v.43c-.41,0-.82-.03-1.23-.03-.46,0-.94.02-1.4.03-1.49-1.64-2.6-3.57-3.78-5.42h-1.5ZM67.21,52.04c-.41,0-.69.05-.99.1v4.81c.25.05.59.08.87.08,2.02,0,2.81-1.33,2.81-2.51,0-1.43-.75-2.48-2.69-2.48Z"
        />
        <path
          fill="#003767"
          d="M81.24,53.13c0-1.15-.63-1.17-1.5-1.18v-.43c.77.02,1.53.03,2.27.03s1.51-.02,2.33-.03v.43c-.87.02-1.5.03-1.5,1.18v8.25c0,1.15.62,1.17,1.5,1.18v.43c-.79,0-1.5-.03-2.22-.03-.79,0-1.56.02-2.38.03v-.43c.87-.02,1.5-.03,1.5-1.18v-8.25Z"
        />
        <path
          fill="#003767"
          d="M101.6,63.13h-.38l-8.59-9.43v6.13c0,2.27.18,2.73,1.96,2.73v.43c-.72,0-1.46-.03-2.19-.03s-1.46.02-2.19.03v-.43c1,0,1.76,0,1.76-2.09v-6.61c0-1.41-.61-1.92-2.02-1.92v-.43c.51.02,1,.03,1.51.03.44,0,.9-.03,1.35-.03.68,1,2.2,2.5,4.08,4.57,1.4,1.55,2.94,3.17,4.06,4.39v-6.54c0-1.51-.34-1.97-1.99-1.99v-.43c.76.02,1.53.03,2.28.03.64,0,1.27-.03,1.91-.03v.43c-1,0-1.54.08-1.54,1.69v9.5Z"
        />
        <path
          fill="#003767"
          d="M117.67,59.71c.23.64.67,2.04.94,2.4.25.33.74.45,1.27.45v.43c-.63,0-1.27-.03-1.89-.03-.8,0-1.59.02-2.4.03v-.43h.29c.41,0,.9-.08.9-.54,0-.18-.13-.64-.24-.95l-.82-2.38h-3.86l-.36,1.15c-.21.69-.44,1.45-.44,1.96,0,.77.54.74,1.12.77h.38v.43c-.64,0-1.3-.03-1.94-.03s-1.33.02-1.99.03v-.43c1-.12,1.18-.25,1.59-1.17.26-.59.46-1.23.68-1.84l2.1-5.87c.13-.38.34-.99.34-1.48,0-.16,0-.29-.03-.43.34-.17.72-.35.95-.72h.28l3.14,8.66ZM112.09,58.01h3.38l-1.76-4.83h-.04l-1.59,4.83Z"
        />
        <path
          fill="#003767"
          d="M128.8,57.56v3.81c0,1.15.62,1.17,1.5,1.18v.43c-.79,0-1.5-.03-2.22-.03-.79,0-1.56.02-2.38.03v-.43c.82.05,1.5-.16,1.5-1.1v-8.33c0-1.15-.62-1.17-1.5-1.18v-.43c.9.02,1.69.03,2.5.03.57,0,1.15-.03,2.2-.03,3.1,0,3.79,1.74,3.79,2.91,0,1.4-1.05,2.43-2.33,2.81,1.49,2.19,2.28,3.5,2.99,4.29.53.59,1.02,1.04,1.86,1.04v.43c-.41,0-.82-.03-1.23-.03-.46,0-.94.02-1.39.03-1.5-1.64-2.6-3.57-3.78-5.42h-1.5ZM129.79,52.04c-.41,0-.69.05-.99.1v4.81c.25.05.59.08.87.08,2.02,0,2.81-1.33,2.81-2.51,0-1.43-.76-2.48-2.69-2.48Z"
        />
        <path
          fill="#003767"
          d="M147.35,61.38c0,1.15.62,1.17,1.5,1.18v.43c-.82-.02-1.58-.03-2.33-.03s-1.5.02-2.27.03v-.43c.87-.02,1.5-.03,1.5-1.18v-3.98l-3.43-4.73c-.48-.67-.56-.64-1.53-.72v-.43c.31.02,1.53.03,2.29.03.67,0,1.33-.03,2-.03v.43c-.26,0-.92,0-.92.34,0,.2.23.58.54,1.02l2.3,3.24,2.15-2.94c.2-.28.64-.8.64-1.18,0-.48-.33-.48-1.17-.48v-.43c.62.02,1.26.03,1.89.03.44,0,.89-.03,1.35-.03v.43c-.69.02-1,.46-1.37.95l-3.14,4.24v4.24Z"
        />
      </g>
      <path
        fill="#003767"
        d="M149.47,29.92c1.12,0,2,.86,2,1.97s-.89,1.98-2.01,1.98-2.03-.87-2.03-1.98.9-1.97,2.03-1.97h.01ZM149.44,30.32c-.85,0-1.51.71-1.51,1.57s.66,1.57,1.54,1.57c.85.01,1.5-.7,1.5-1.56s-.65-1.58-1.51-1.58h-.01ZM149.14,32.91h-.46v-1.97c.18-.02.43-.06.76-.06.37,0,.54.06.67.16.12.08.2.23.2.42,0,.24-.18.4-.41.47v.02c.19.06.29.22.35.48.06.3.11.41.14.48h-.48c-.06-.07-.1-.24-.16-.48-.04-.2-.16-.3-.41-.3h-.22v.78ZM149.15,31.81h.22c.25,0,.46-.08.46-.29,0-.18-.13-.3-.42-.3-.12,0-.2.01-.25.02v.56Z"
      />
    </svg>
  );
}
